import { render } from "./UserAccounts.vue?vue&type=template&id=9b2b3546&scoped=true"
import script from "./UserAccounts.vue?vue&type=script&lang=js"
export * from "./UserAccounts.vue?vue&type=script&lang=js"

import "./UserAccounts.vue?vue&type=style&index=0&id=9b2b3546&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b2b3546"]])

export default __exports__